<script setup lang="ts">
import { CheckboxBase } from '@/features/ui-kit';
import { MMText } from '@mm-frontend/mm-web-ui-kit';
import { useDevToolbar } from '../../business/form';
import { EDebugFeature } from '../../models';

const { formData } = useDevToolbar();
</script>

<template>
  <div class="debug-tab">
    <pre>error: {{ formData.FPS.error }}</pre>
    <CheckboxBase v-model="formData[EDebugFeature.MEMORY].value">
      <MMText>Memory Usage</MMText>
    </CheckboxBase>

    <CheckboxBase v-model="formData[EDebugFeature.FPS].value">
      <MMText>Fps</MMText>
    </CheckboxBase>
  </div>
</template>

<style scoped lang="stylus">
.debug-tab
  display flex
  flex-direction column
  gap 8px
</style>
